import { useTranslation } from 'react-i18next';
import Styles from './AboutDialog.module.scss';
import { Dialog, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import type { AboutInfo } from '@/Models/AboutInfo';
import ThirdPartySoftware from './ThirdPartySoftware';

function AboutDialog({ open, onClose, data }: Readonly<{
    open: boolean; onClose: () => void; data: AboutInfo;
}>): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} className={Styles.aboutDialog}>
            <DialogTitle>
                {t('AboutRISonWEB')}
            </DialogTitle>

            <DialogContent>
                <div className={Styles.aboutUs}>
                    <div className={Styles.layout}>
                        <div className={Styles.leftColumn}>
                            <div className={Styles.categoryBorder}>
                                <h6 className={Styles.labelTitle}>{ t('SupportInformation') }</h6>
                                <div>
                                    <div className={Styles.supportInformation}>
                                        <b>{ t('CompanyName') }</b>
                                        <span>: </span>
                                        <span>{data.CompanyName}</span>
                                    </div>
                                    <div className={Styles.supportInformation}>
                                        <b>{ t('Email') }</b>
                                        :
                                        { ' ' }
                                        <a
                                            href={'mailto:' + data.SupportMailAddress}
                                        >
                                            {data.SupportMailAddress}
                                        </a>
                                    </div>
                                    <div className={Styles.supportInformation}>
                                        <b>{ t('Telephone') }</b>
                                        <span>: </span>
                                        <span>{data.SupportTelephone}</span>
                                    </div>
                                    <div className={Styles.supportInformation}>
                                        <a
                                            href={'/legacy/System/GetTeamViewer?location=' + data.TeamViewerLink}
                                        >
                                            { t('StartTeamViewer') }
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className={Styles.categoryBorder}>
                                <h6 className={Styles.labelTitle}>{ t('CompanyInformation') }</h6>
                                <div className={Styles.rowContent}>
                                    <img alt="Logo" src="./icons/icnCompanyInformation.png" height="50px" />
                                    <p>
                                        DH Healthcare GmbH
                                        <br />
                                        Konrad-Zuse-Platz 1-3
                                        <br />
                                        53227 Bonn, Germany
                                        <br />
                                        <b>{ t('Website') }</b>
                                        :
                                        { ' ' }
                                        <a
                                            target="_blank"
                                            href="https://dedalusgroup.de"
                                            rel="noreferrer"
                                        >
                                            www.dedalusgroup.de
                                        </a>
                                        <br />
                                        Copyright (C) 2026
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={Styles.rightColumn}>
                            <div className={Styles.categoryBorder}>
                                <h6 className={Styles.labelTitle}>{t('SoftwareIdentification')}</h6>
                                <b>{ t('Version') }</b>
                                : Build
                                { ' ' }
                                {data.Version}
                                <br />
                                <br />
                                <b>{t('ReleaseDate')}</b>
                                { ': ' }
                                {data.ReleaseDate}
                                <h6 className={Styles.softwareListTitle}>{t('UsedThirdPartySoftwareComponents')}</h6>
                                <ThirdPartySoftware />
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default AboutDialog;
